import { QuestionSetLabel } from "./question-set-label";
import { QuestionType } from "./question-type";
import { ListQuestion } from "app/shared/models/list-question";

export class ChecklistQuestion extends ListQuestion {

    private _answers:{};

    constructor() {
        super();
        this._answers = {};
        this.type = QuestionType.Checklist;
    }

    public addAnswer(label:QuestionSetLabel) {
        this._answers[label.id] = label;
    }

    public removeAnswer(label:QuestionSetLabel) {
        if (this._answers.hasOwnProperty(label.id)) {
            delete this._answers[label.id];
        }
    }

    public get answerDisplayText() {
        let description = this.getAnswerLabels()
        .reduce((prev, curr:QuestionSetLabel) => prev + curr.label + " ", "");
        
        return description;
    }

    public hasAnswer(label:QuestionSetLabel) {
        return this._answers[label.id];
    }

    public get isFilledOut() : boolean {
        // we let nothing be an option as well.
        // TODO: stephen we may at some point require at least one option to be checked...
		return true;
	}

    public get answerForSave() {
        return Object.assign({}, this._answers); // just copy them over onto a new object
    }

    public setSavedAnswer(answer:any, labels:QuestionSetLabel[]) {
        Object.keys(answer).forEach(key => {
            let label = labels.find(l => l.id == key);
            if (label) {
                this.addAnswer(label);
            }
        })
    }

    private getAnswerLabels() {
        return Object.keys(this._answers)
        .filter(a => this._answers[a].label)
        .map( a => this._answers[a]);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/checklist-question.ts